import { SelectionModel } from "@angular/cdk/collections";
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { HtlBlockNumber, HtlService } from "../../htl/htl.service";
import { HoldItemList } from "../../shared/models/holdItemList.model";
import * as HoldItemListColums from "../holdItemListColums";
import { UpdateExpiringHoldItemListDialogComponent } from "../update-expiring-hold-item-list-dialog/update-expiring-hold-item-list-dialog.component";
import { UpdateHoldItemListDialogComponent } from "../update-hold-item-list-dialog/update-hold-item-list-dialog.component";
import { LocalStorageService } from "../../shared/local-storage.service";
import { ExcelExportComponent } from "@progress/kendo-angular-excel-export";
import { forkJoin } from "rxjs";
import { DataStateChangeEvent, ExcelExportEvent, GridComponent, GridDataResult } from "@progress/kendo-angular-grid";
import { Helicopter } from "../../shared/models/helicopter.model";
import { process, State } from "@progress/kendo-data-query";
import { AppConfigType } from "../../shared/models/appConfig.model";
import moment from "moment";
import { HHMM } from "@rrsolutionsit/atl-utils";

@Component({
    selector: "app-hold-item-list-table",
    templateUrl: "./hold-item-list-table.component.html",
    styleUrls: ["./hold-item-list-table.component.scss"],
    standalone: false,
})
export class HoldItemListTableComponent implements OnInit, OnChanges {
    @Input({ required: true }) aircraft: Helicopter;
    @Input({ required: true }) helicopterData: any;

    @ViewChild("grid", { static: false }) grid: GridComponent;

    public htlBlockNumber: number = -1;
    public htlBlockNumberArray: HtlBlockNumber[] = [];
    public displayedColumns: string[] = HoldItemListColums.columns;
    public selection = new SelectionModel<HoldItemList>(false, []);

    public showAddExceptionBtn = false;

    private _selectedHilId: number;

    public isCamo = false;
    private _userSession;

    public gridColumns = [];

    public pageSizes = [25, 50, 100, 200];

    public gridView: GridDataResult;
    public gridData = [];
    public data: any[] = [];

    public filename: string;

    public showFlightNumber = false;

    public showOpenItems = true;

    public totalHours: string = "00:00";
    public totalCycles: number = 0;

    public state: State = {
        skip: 0,
        take: this.pageSizes[0],
    };

    constructor(
        private _router: ActivatedRoute,
        private _htlService: HtlService,
        private _dialog: MatDialog,
        private _localStorageService: LocalStorageService,
    ) {
        this._userSession = this._localStorageService.getUserLocalStorageObject();
    }

    ngOnInit(): void {
        if (this._userSession.htlAccountTypes.length > 0) {
            switch (this._userSession.htlAccountTypes[0].id) {
                case 1:
                    this.isCamo = true;
                    break;
                case 2:
                    this.isCamo = true;
                    break;
            }
        }

        if (JSON.parse(this._userSession.appConfigs.find((a) => a.type === AppConfigType.flightNumber).enabled)) {
            this.showFlightNumber = true;
        }

        this.gridColumns = [
            { field: "itemNumber", title: "Nr.", width: "60px", isGroup: false },
            {
                field: "opening",
                title: "Opening",
                isGroup: true,
                cols: [
                    { field: "openingDateText", title: "Opening Date", width: "100px" },
                    { field: "openingHTLBlock", title: "ATL Block", width: "100px" },
                    { field: "openingHTLDocument", title: "ATL Page", width: "100px" },
                ],
            },
            { field: "description", title: "Description", width: "300px", isGroup: false },
            { field: "ataChap", title: "ATA Chap.", width: "100px", isGroup: false },
            { field: "melRef", title: "MEL Ref.", width: "100px", isGroup: false },
            {
                field: "expExp",
                title: "Expected Expiring",
                isGroup: true,
                cols: [
                    { field: "expExpDateText", title: "Date", width: "100px" },
                    { field: "expExpFlightHours", title: "Flight Hours", width: "100px" },
                    { field: "expExpFlightNumber", title: "Flight Number", width: "100px", disabled: !this.showFlightNumber },
                    { field: "expExpCycles", title: "Cycles", width: "100px" },
                ],
            },
            { field: "exeExpSignatureName", title: "Authorized Signature", width: "100px", isGroup: false },
            {
                field: "newExp1",
                title: "New Expiring 1st Extension",
                isGroup: true,
                cols: [
                    { field: "exe1Document", title: "Document", width: "100px" },
                    { field: "exe1DateText", title: "Date", width: "100px" },
                    { field: "exe1FlightHours", title: "Flight Hours", width: "100px" },
                    { field: "exe1FlightNumber", title: "Flight Number", width: "100px", disabled: !this.showFlightNumber },
                    { field: "exe1Cycles", title: "Cycles", width: "100px" },
                ],
            },
            { field: "exe1SignatureName", title: "Authorized Signature", width: "100px", isGroup: false },
            {
                field: "newExp2",
                title: "New Expiring 2nd Extension",
                isGroup: true,
                cols: [
                    { field: "exe2Document", title: "Document", width: "100px" },
                    { field: "exe2DateText", title: "Date", width: "100px" },
                    { field: "exe2FlightHours", title: "Flight Hours", width: "100px" },
                    { field: "exe2FlightNumber", title: "Flight Number", width: "100px", disabled: !this.showFlightNumber },
                    { field: "exe2Cycles", title: "Cycles", width: "100px" },
                ],
            },
            { field: "exe2SignatureName", title: "Authorized Signature", width: "100px", isGroup: false },
            {
                field: "closure",
                title: "Closure",
                isGroup: true,
                cols: [
                    { field: "closureDateText", title: "Date", width: "100px" },
                    { field: "closureHTLBlock", title: "ATL Block", width: "100px" },
                    { field: "closureHTLDocument", title: "ATL Page", width: "100px" },
                ],
            },
            { field: "cs", title: "CS", isGroup: true, cols: [{ field: "closureSignatureName", title: "Signature", width: "100px" }] },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["aircraft"] && changes["aircraft"].currentValue) {
            this._htlService.getHtlBlockNumbersByHelicopterId(this.aircraft.id).subscribe((result) => {
                this.htlBlockNumberArray = result.reverse();
                this.showOpenItems = true;
                this.state.skip = 0;
                this.state.take = this.pageSizes[0];
                this.htlBlockNumber = -1;
                this.totalHours = HHMM.sumTimes(this.helicopterData?.totalHours, this.helicopterData?.flightSUM).value;
                this.totalCycles = this.helicopterData?.totalCycles + this.helicopterData?.currentCycles;
                this.populateGrid();
                this.filename = "HoldItems_" + this.aircraft.registrationMark.trim();
            });
        }
    }

    onHtlBlockNumberChange(event: MatSelectChange) {
        this.populateGrid();
    }

    private populateGrid() {
        if (this.htlBlockNumber === -1) {
            const getHoldItems = [];
            this.htlBlockNumberArray.forEach((element) => {
                getHoldItems.push(this._htlService.getHoldItemListByBlockId(element.id));
            });
            forkJoin(...getHoldItems).subscribe((result) => {
                this.data = [];
                result.forEach((element) => {
                    const item = element as HoldItemList[];
                    item.forEach((item) => {
                        if (this.showOpenItems && item.closureSignatureName !== null) {
                            return;
                        }
                        if (item.openingDate) {
                            item.openingDateText = moment(item.openingDate).format("DD-MM-YYYY");
                        }
                        if (item.expExpDate) {
                            item.expExpDateText = moment(item.expExpDate).format("DD-MM-YYYY");
                        }
                        if (item.exe1Date) {
                            item.exe1DateText = moment(item.exe1Date).format("DD-MM-YYYY");
                        }
                        if (item.exe2Date) {
                            item.exe2DateText = moment(item.exe2Date).format("DD-MM-YYYY");
                        }
                        if (item.closureDate) {
                            item.closureDateText = moment(item.closureDate).format("DD-MM-YYYY");
                        }
                        this.data.push(item);
                    });
                });
                this.showAddExceptionBtn = false;
                this.gridView = process(this.data, this.state);
            });
        } else {
            this.showAddExceptionBtn = false;
            this._htlService.getHoldItemListByBlockId(this.htlBlockNumber).subscribe((resultArray) => {
                this.data = resultArray;
                this.data.forEach((item) => {
                    if (item.openingDate) {
                        item.openingDateText = moment(item.openingDate).format("DD-MM-YYYY");
                    }
                    if (item.expExpDate) {
                        item.expExpDateText = moment(item.expExpDate).format("DD-MM-YYYY");
                    }
                    if (item.exe1Date) {
                        item.exe1DateText = moment(item.exe1Date).format("DD-MM-YYYY");
                    }
                    if (item.exe2Date) {
                        item.exe2DateText = moment(item.exe2Date).format("DD-MM-YYYY");
                    }
                    if (item.closureDate) {
                        item.closureDateText = moment(item.closureDate).format("DD-MM-YYYY");
                    }
                });
                if (this.showOpenItems) {
                    this.data = this.data.filter((r) => r.closureSignatureName === null);
                }
                this.gridView = process(this.data, this.state);
            });
        }
    }

    openCreateHoldItemListDialog() {
        const dialogRef = this._dialog.open(UpdateHoldItemListDialogComponent, {
            disableClose: true,
            width: "50%",
            data: {
                helicopterId: this.aircraft.id,
                showFlightNumber: this.showFlightNumber,
                helicopterData: this.helicopterData,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.populateGrid();
        });
    }

    openNewExpiringDialog() {
        const dialogRef = this._dialog.open(UpdateExpiringHoldItemListDialogComponent, {
            disableClose: true,
            width: "50%",
            data: {
                holdItemListid: this._selectedHilId,
                holdItem: this.data.filter((r) => r.id === this._selectedHilId)[0],
                showFlightNumber: this.showFlightNumber,
                helicopterData: this.helicopterData,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {
            this.populateGrid();
        });
    }

    public excelExportData(e: ExcelExportEvent) {
        const rows = e.workbook.sheets[0].rows;

        // set alternating row color
        let altIdx = 0;
        rows.forEach((row) => {
            if (row.type === "data") {
                if (altIdx % 2 !== 0) row.cells.forEach((cell) => (cell.background = "#f2f7ff"));
                altIdx++;
            }
        });
    }

    public onSelectionChange(event) {
        this.showAddExceptionBtn = false;
        if (event.selectedRows.length >= 1) {
            this._selectedHilId = event.selectedRows[0].dataItem.id;
            this.showAddExceptionBtn = true;
        }
    }

    dataStateChange(state: DataStateChangeEvent) {
        this.state = state;
        this.gridView = process(this.data, this.state);
    }

    public applyOpenItemsFilter() {
        if (this.showOpenItems) {
            this.state.skip = 0;
        }
        this.populateGrid();
    }
}
